import { render } from "./BuildingWithoutBackboneForm.vue?vue&type=template&id=5454986a&scoped=true"
import script from "./BuildingWithoutBackboneForm.vue?vue&type=script&lang=js"
export * from "./BuildingWithoutBackboneForm.vue?vue&type=script&lang=js"

import "./BuildingWithoutBackboneForm.vue?vue&type=style&index=0&id=5454986a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5454986a"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
